export const SHOW_ADD_TO_CART_MODAL = 'globalState/SHOW_ADD_TO_CART_MODAL';
export const CLOSE_ADD_TO_CART_MODAL = 'globalState/CLOSE_ADD_TO_CART_MODAL';
export const CACHE_CATEGORY_LIST = 'globalState/CACHE_CATEGORY_LIST';
export const SET_SELECTED_PRODUCT_VENDOR_NAME = 'globalState/SET_SELECTED_PRODUCT_VENDOR_NAME';
